import Swal from 'sweetalert2'

function microbaWarning (config) {
  const title = (config && config.title !== undefined) ? config.title : 'Warning'
  const text = (config && config.text !== undefined) ? config.text : ''

  const defaultConfig = {
    title: title,
    html: text,
    type: 'warning'
  }
  return Swal.fire(defaultConfig)
}

function microbaSuccess (config) {
  const title = (config && config.title !== undefined) ? config.title : 'Success'
  const text = (config && config.text !== undefined) ? config.text : ''
  const defaultConfig = {
    title: title,
    html: text,
    type: 'success'
  }
  return Swal.fire(defaultConfig)
}

function microbaFailure (config) {
  const title = (config && config.title !== undefined) ? config.title : 'Error'
  const text = (config && config.text !== undefined) ? config.text : ''
  const defaultConfig = {
    title: title,
    html: text,
    type: 'error'
  }
  return Swal.fire(defaultConfig)
}

function microbaConfirm (config) {
  const title = (config && config.title !== undefined) ? config.title : 'Are you sure?'
  const text = (config && config.text !== undefined) ? config.text : ''
  const confirmButtonText = (config && config.confirmButtonText !== undefined) ? config.confirmButtonText : 'Yes'
  const cancelButtonText = (config && config.cancelButtonText !== undefined) ? config.cancelButtonText : 'No'
  const defaultConfig = {
    title: title,
    html: text,
    confirmButtonText: confirmButtonText,
    cancelButtonText: cancelButtonText,
    type: 'warning',
    showCancelButton: true
  }
  return Swal.fire(defaultConfig)
}

function microbaAnswer (config) {
  const title = (config && config.title !== undefined) ? config.title : ''
  const text = (config && config.text !== undefined) ? config.text : ''
  const defaultConfig = {
    title: title,
    html: text,
    type: 'question'
  }
  return Swal.fire(defaultConfig)
}

class microbaLoader {
  static showLoader (config) {
    const defaultConfig = {
      title: 'Please wait',
      html: (config && config.text !== undefined) ? config.text : null
    }
    Swal.fire(defaultConfig)
    return Swal.showLoading()
  }

  static hideLoader () {
    return Swal.close()
  }
}

export {
  microbaWarning,
  microbaConfirm,
  microbaLoader,
  microbaSuccess,
  microbaAnswer,
  microbaFailure
}



// WEBPACK FOOTER //
// ./src/services/notificationServices.js